import React from 'react';

const EnterIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg height="16" width="16" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 6.61608L12 6.66675C12 8.87608 10.2093 10.6667 8 10.6667L7.054 10.6667L4 10.6667"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M12.0013 6.6134L12.0013 3.3334" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6 8.66675L4 10.6667L6 12.6667" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default EnterIcon;
